import Vue from 'vue';
import { groupMedicalInsuranceSelectValues, newsValues } from './mocks';
import insuraceFeeInfo from '@/assets/data/group.json';
import maruki from '@/assets/data/maruki.json';

/**
 * News
 */

export const setDefaultNewsCard = (card) => {
  Vue.set(card.items[0], 'value', 1000);
};

// Update news card
export const updateNewsCard = (card, age, gender) => {
  const cardState = { disabled: false };
  const value = card.items[0].value;
  let insuredAge = age; //保険年齢
  if(maruki.showPremiumsForNextYearFlag){ //maruki.jsonにて翌年分の保険料表示を行う設定の場合、現在年齢に+1して翌年分の保険料を表示する
    const today = new Date();
    const baseDate = new Date(maruki.dateOfReversionToCurrentYearsPremium[0], maruki.dateOfReversionToCurrentYearsPremium[1]-1, maruki.dateOfReversionToCurrentYearsPremium[2]);
    if(today < baseDate){
      insuredAge++;
    }
  }
  const foundAgeItem = maruki.premiumsData
    .find((item) => item.sex === gender)
    .ages.find((items) => items.age === insuredAge);

  let insuranceFee = null;
  let about = null;
  if (foundAgeItem && foundAgeItem.insurance_fee) {
    Vue.set(
      card.items[0],
      'values',
      newsValues
        .slice(0, foundAgeItem.insurance_fee.length)
        .sort((a, b) => a.value - b.value)
    );
    const selectedValueIndex = card.items[0].values.findIndex(
      (item) => item.value === value
    );
    insuranceFee = foundAgeItem.insurance_fee[selectedValueIndex];
    about = Math.ceil(insuranceFee / 6);
  }
  if (!insuranceFee) {
    insuranceFee = null;
    about = null;
    cardState.disabled = true;
  }
  Vue.set(card.footer, 'money', insuranceFee);
  Vue.set(card.footer, 'about', about);
  return cardState;
};

/**
 * Group medical insurance
 */
let mappedInsuraceFeeInfo = {};
insuraceFeeInfo.forEach((fee) => {
  const mappedObj = {
    type: fee.type,
  };
  if (fee.ages) {
    mappedObj.ages = fee.ages;
  } else {
    mappedObj.ages = [
      {
        start_age: 0,
        end_age: 1000, // a random high number to include all ages
        insurance_fee_base: fee.insurance_fee_base,
      },
    ];
  }

  mappedInsuraceFeeInfo = {
    ...mappedInsuraceFeeInfo,
    [`${fee.type}型`]: mappedObj,
  };
});

// Calculate insurance fee based on medical group type
const calculateInsuranceFee = (card, personAge, listItem, value, type) => {
  const insuranceItem = mappedInsuraceFeeInfo[type].ages.find(
    (age) => personAge >= age.start_age && personAge <= age.end_age
  );
  Vue.set(
    card.items[listItem.itemIndex].list[listItem.listItemIndex],
    'insuranceFee',
    insuranceItem ? insuranceItem.insurance_fee_base * value : 0
  );
  return card.items[listItem.itemIndex].list[listItem.listItemIndex];
};

// Initialize group medical insurance
export const initGeoupMedicalInsurace = (card, age) => {
  if (age >= 80 && age <= 84) {
    Vue.set(card, 'itemsOpen', []);
    // A型
    Vue.set(card.items[0].list[0].sections[0], 'value', 0);
    // B型
    Vue.set(card.items[0].list[1].sections[0], 'value', 0);
    // C型
    Vue.set(card.items[0].list[2].sections[0], 'value', 0);
    // D型
    Vue.set(card.items[0].list[3].sections[0], 'value', 0);
    // X型
    Vue.set(card.items[4].list[1].sections[0], 'value', 0);
  }
};

// Update medical group insurance
export const updateGroupMedicalInsurance = (card, age, state, insuranceType) => {
  // check whether card disabled
  if (state && state.disabled) {
    Vue.set(card.footer, 'money', null);
    return;
  }

  // map sections
  let mappedSections = {};
  card.items.forEach((item, itemIndex) => {
    item.list.forEach((listItem, listItemIndex) => {
      mappedSections = {
        ...mappedSections,
        [listItem.label]: {
          label: listItem.label,
          itemIndex,
          listItemIndex,
          sections: [...listItem.sections],
        },
      };
    });
  });

  // experetions for medical groups
  const experetions = [
    checkGroupMedicalInsuranceA(card, age, mappedSections),
    checkGroupMedicalInsuranceB(card, age, mappedSections, insuranceType),
    checkGroupMedicalInsuranceC(card, age, mappedSections, insuranceType),
    checkGroupMedicalInsuranceD(card, age, mappedSections, insuranceType),
    checkGroupMedicalInsuranceE(card, age, mappedSections),
    checkGroupMedicalInsuranceJ(card, age, mappedSections),
    checkGroupMedicalInsuranceK(card, age, mappedSections),
    checkGroupMedicalInsuranceP(card, age, mappedSections),
    checkGroupMedicalInsuranceY(card, age, mappedSections),
    checkGroupMedicalInsuranceZ(card, age, mappedSections),
    checkGroupMedicalInsuranceX(card, age, mappedSections),
    checkGroupMedicalInsuranceG(card, age, mappedSections),
    checkGroupMedicalInsuranceM(card, age, mappedSections),
    checkGroupMedicalInsuranceN(card, age, mappedSections),
  ];

  // set total insurance fee
  const totalInsuranceFee = experetions.reduce(
    (previousValue, currentValue) => previousValue + currentValue.insuranceFee,
    0
  );
  Vue.set(card.footer, 'money', totalInsuranceFee || null);
};

// Check medical insurance for group A
const checkGroupMedicalInsuranceA = (card, age, mappedSections) => {
  const groupType = 'A型';
  let updatedSection = {
    disabled: false,
    value: mappedSections[groupType].sections[0].value,
  };

  const listItem = mappedSections[groupType];
  // get selected text
  let selectedText = '-';
  const foundValueItem = mappedSections[groupType].sections[0].values.find(
    (item) => item.value === updatedSection.value
  );
  if (foundValueItem) {
    selectedText = foundValueItem.text;
  } else {
    updatedSection.value = 0;
  }

  // age condtion
  if (age >= 80 && age <= 84) {
    updatedSection.value = 0;
    updatedSection.disabled = true;
  }

  setGroupMedicalSection(0, card, listItem, updatedSection);

  setGroupMedicalSection(1, card, listItem, {
    value: getMedicalInsuranceLabelPatternA(updatedSection.value, selectedText),
  });

  return calculateInsuranceFee(
    card,
    age,
    mappedSections[groupType],
    updatedSection.value,
    groupType
  );
};

// Check medical insurance for group B
const checkGroupMedicalInsuranceB = (card, age, mappedSections, insuranceType) => {
  const groupType = 'B型';
  let updatedSection = {
    disabled: false,
    value: mappedSections[groupType].sections[0].value,
  };

  // Condition based on A型 value
  if (mappedSections['A型'].sections[0].value < 3) {
    updatedSection.disabled = true;
    updatedSection.value = 0;
  } else {
    const values = groupMedicalInsuranceSelectValues['B型'][0];
    updatedSection.values = values.slice(
      0,
      values.findIndex(
        (item) => item.value === mappedSections['A型'].sections[0].value
      ) + 1
    );
  }

  // age condtion
  if (age >= 80 && age <= 84) {
    updatedSection.value = 0;
    updatedSection.disabled = true;
  }

  // Aの変更があった場合0にリセットする
  if (insuranceType && insuranceType === 'A') {
    updatedSection.value = 0;
  }

  const listItem = mappedSections[groupType];

  setGroupMedicalSection(0, card, listItem, {
    ...updatedSection,
  });

  return calculateInsuranceFee(
    card,
    age,
    mappedSections[groupType],
    updatedSection.value,
    groupType
  );
};

// Check medical insurance for group C
const checkGroupMedicalInsuranceC = (card, age, mappedSections, insuranceType) => {
  const groupType = 'C型';
  let updatedSection = {
    disabled: false,
    value: mappedSections[groupType].sections[0].value,
  };

  // condition based on A型 value
  if (mappedSections['A型'].sections[0].value < 3) {
    updatedSection.disabled = true;
    updatedSection.value = 0;
  } else {
    const values = groupMedicalInsuranceSelectValues['C型'][0];
    updatedSection.values = values.slice(
      0,
      values.findIndex(
        (item) => item.value === mappedSections['A型'].sections[0].value
      ) + 1
    );
  }

  // age condtion
  if (age >= 80 && age <= 84) {
    updatedSection.value = 0;
    updatedSection.disabled = true;
  }
  // Aの変更があった場合0にリセットする
  if (insuranceType && insuranceType === 'A') {
    updatedSection.value = 0;
  }

  const listItem = mappedSections[groupType];

  // get selected text
  let selectedText = '-';
  const foundValueItem = mappedSections[groupType].sections[0].values.find(
    (item) => item.value === updatedSection.value
  );
  if (foundValueItem) {
    selectedText = foundValueItem.text;
  } else {
    updatedSection.value = 0;
  }

  setGroupMedicalSection(0, card, listItem, {
    ...updatedSection,
  });

  setGroupMedicalSection(1, card, listItem, {
    value: getMedicalInsuranceLabelPatternA(updatedSection.value, selectedText),
  });

  return calculateInsuranceFee(
    card,
    age,
    mappedSections[groupType],
    updatedSection.value,
    groupType
  );
};

// Check medical insurance for group D
const checkGroupMedicalInsuranceD = (card, age, mappedSections, insuranceType) => {
  const groupType = 'D型';
  let updatedSection = {
    disabled: false,
    value: mappedSections[groupType].sections[0].value,
  };

  const abcValues = [
    mappedSections['A型'].sections[0].value,
    mappedSections['B型'].sections[0].value,
    mappedSections['C型'].sections[0].value,
  ];
  // condition based on A/B/C
  if (abcValues.every((value) => value >= 3)) {
    updatedSection.disabled = false;
    const values = groupMedicalInsuranceSelectValues['D型'][0];
    updatedSection.values = values.slice(
      0,
      values.findIndex((item) => item.value === Math.min(...abcValues)) + 1
    );
  } else {
    updatedSection.disabled = true;
    updatedSection.value = 0;
  }
  // age condtion
  if (age >= 80 && age <= 84) {
    updatedSection.value = 0;
    updatedSection.disabled = true;
  }
  // A/B/Cの変更があった場合0にリセットする
  if (insuranceType) {
    updatedSection.value = 0;
    if(insuranceType === 'A'){
      updatedSection.disabled = true;
    }
  }
  const listItem = mappedSections[groupType];
  setGroupMedicalSection(0, card, listItem, {
    ...updatedSection,
  });

  return calculateInsuranceFee(
    card,
    age,
    mappedSections[groupType],
    updatedSection.value,
    groupType
  );
};

// Check medical insurance for group E
const checkGroupMedicalInsuranceE = (card, age, mappedSections) => {
  let disabled = false;

  const groupType = 'E型';
  const listItem = mappedSections[groupType];
  const selectedValue = mappedSections[groupType].sections[0].value;
  const selectedText = mappedSections[groupType].sections[0].values.find(
    (item) => item.value === selectedValue
  ).text;

  setGroupMedicalSection(0, card, listItem, {
    disabled,
  });

  setGroupMedicalSection(1, card, listItem, {
    value: getMedicalInsuranceLabelPatternA(selectedValue, selectedText),
  });
  setGroupMedicalSection(2, card, listItem, {
    value: getMedicalInsuranceLabelPatternC(selectedValue, selectedText),
  });
  return calculateInsuranceFee(
    card,
    age,
    mappedSections[groupType],
    mappedSections[groupType].sections[0].value,
    groupType
  );
};

// Check medical insurance for group J
const checkGroupMedicalInsuranceJ = (card, age, mappedSections) => {
  const groupType = 'J型';
  let updatedSection = {
    disabled: false,
    value: mappedSections[groupType].sections[0].value,
  };

  // condition based on K型
  if (mappedSections['K型'].sections[0].value > 0) {
    updatedSection.disabled = true;
    updatedSection.value = 0;
  }

  const listItem = mappedSections[groupType];
  // get selected text
  let selectedText = '-';
  const foundValueItem = mappedSections[groupType].sections[0].values.find(
    (item) => item.value === updatedSection.value
  );
  if (foundValueItem) {
    selectedText = foundValueItem.text;
  } else {
    updatedSection.value = 0;
  }

  setGroupMedicalSection(0, card, listItem, {
    ...updatedSection,
  });
  setGroupMedicalSection(1, card, listItem, {
    value: getMedicalInsuranceLabelPatternB(updatedSection.value, selectedText),
  });
  return calculateInsuranceFee(
    card,
    age,
    mappedSections[groupType],
    updatedSection.value,
    groupType
  );
};

// Check medical insurance for group K
const checkGroupMedicalInsuranceK = (card, age, mappedSections) => {
  const groupType = 'K型';
  let updatedSection = {
    disabled: false,
    value: mappedSections[groupType].sections[0].value,
  };

  // condition based on J型
  if (mappedSections['J型'].sections[0].value > 0) {
    updatedSection.disabled = true;
    updatedSection.value = 0;
  }

  const listItem = mappedSections[groupType];

  setGroupMedicalSection(0, card, listItem, {
    ...updatedSection,
  });
  return calculateInsuranceFee(
    card,
    age,
    mappedSections[groupType],
    updatedSection.value,
    groupType
  );
};

// Check medical insurance for group P
const checkGroupMedicalInsuranceP = (card, age, mappedSections) => {
  const groupType = 'P型';
  let updatedSection = {
    disabled: false,
    value: mappedSections[groupType].sections[0].value,
  };

  // condition based on J型/K型
  const jkValues = [
    mappedSections['J型'].sections[0].value,
    mappedSections['K型'].sections[0].value,
  ];
  if (jkValues.every((value) => value == 0)) {
    updatedSection.disabled = true;
    updatedSection.value = 0;
  }

  const listItem = mappedSections[groupType];

  setGroupMedicalSection(0, card, listItem, {
    ...updatedSection,
  });

  return calculateInsuranceFee(
    card,
    age,
    mappedSections[groupType],
    updatedSection.value,
    groupType
  );
};

// Check medical insurance for group Y
const checkGroupMedicalInsuranceY = (card, age, mappedSections) => {
  const groupType = 'Y型';
  let updatedSection = {
    disabled: false,
    value: mappedSections[groupType].sections[0].value,
  };

  // condition based on A型/E型/G型
  const aegValues = [
    mappedSections['A型'].sections[0].value,
    mappedSections['E型'].sections[0].value,
    mappedSections['G型'].sections[0].value,
  ];
  if (aegValues.every((value) => value == 0)) {
    updatedSection.disabled = true;
    updatedSection.value = 0;
  }

  // age condtion
  if (age < 15) {
    updatedSection.value = 0;
    updatedSection.disabled = true;
  } else if (age < 80) {
    // do nothing
  } else if (age < 85) {
    updatedSection.value = 0;
    updatedSection.disabled = true;
  }

  const listItem = mappedSections[groupType];

  setGroupMedicalSection(0, card, listItem, {
    ...updatedSection,
  });

  return calculateInsuranceFee(
    card,
    age,
    mappedSections[groupType],
    updatedSection.value,
    groupType
  );
};

// Check medical insurance for group Z
const checkGroupMedicalInsuranceZ = (card, age, mappedSections) => {
  const groupType = 'Z型';
  let updatedSection = {
    disabled: false,
    value: mappedSections[groupType].sections[0].value,
  };

  // condition based on A型/E型
  const aegValues = [
    mappedSections['A型'].sections[0].value,
    mappedSections['E型'].sections[0].value,
  ];
  if (aegValues.every((value) => value == 0)) {
    updatedSection.disabled = true;
    updatedSection.value = 0;
  }

  // condition based on X型
  if (mappedSections['X型'].sections[0].value > 0) {
    updatedSection.disabled = true;
    updatedSection.value = 0;
  }

  const listItem = mappedSections[groupType];

  setGroupMedicalSection(0, card, listItem, {
    ...updatedSection,
  });

  return calculateInsuranceFee(
    card,
    age,
    mappedSections[groupType],
    updatedSection.value,
    groupType
  );
};

// Check medical insurance for group X
const checkGroupMedicalInsuranceX = (card, age, mappedSections) => {
  const groupType = 'X型';
  let updatedSection = {
    disabled: false,
    value: mappedSections[groupType].sections[0].value,
  };

  // condition based on A型/E型
  const aegValues = [
    mappedSections['A型'].sections[0].value,
    mappedSections['E型'].sections[0].value,
  ];
  if (aegValues.every((value) => value == 0)) {
    updatedSection.disabled = true;
    updatedSection.value = 0;
  }

  // condition based on Z型
  if (mappedSections['Z型'].sections[0].value > 0) {
    updatedSection.disabled = true;
    updatedSection.value = 0;
  }

  const listItem = mappedSections[groupType];

  setGroupMedicalSection(0, card, listItem, {
    ...updatedSection,
  });

  return calculateInsuranceFee(
    card,
    age,
    mappedSections[groupType],
    updatedSection.value,
    groupType
  );
};

// Check medical insurance for group G
const checkGroupMedicalInsuranceG = (card, age, mappedSections) => {
  let disabled = false;

  const groupType = 'G型';
  const listItem = mappedSections[groupType];
  const selectedValue = mappedSections[groupType].sections[0].value;
  const selectedText = mappedSections[groupType].sections[0].values.find(
    (item) => item.value === selectedValue
  ).text;

  setGroupMedicalSection(0, card, listItem, {
    disabled,
  });
  setGroupMedicalSection(1, card, listItem, {
    value: getMedicalInsuranceLabelPatternA(selectedValue, selectedText),
  });
  setGroupMedicalSection(2, card, listItem, {
    value: getMedicalInsuranceLabelPatternC(selectedValue, selectedText),
  });
  return calculateInsuranceFee(
    card,
    age,
    mappedSections[groupType],
    mappedSections[groupType].sections[0].value,
    groupType
  );
};

// Check medical insurance for group M
const checkGroupMedicalInsuranceM = (card, age, mappedSections) => {
  const groupType = 'M型';
  let updatedSection = {
    disabled: false,
    value: mappedSections[groupType].sections[0].value,
  };

  // condition based on N型
  if (mappedSections['N型'].sections[0].value > 0) {
    updatedSection.disabled = true;
    updatedSection.value = 0;
  }

  const listItem = mappedSections[groupType];
  // get selected text
  let selectedText = '-';
  const foundValueItem = mappedSections[groupType].sections[0].values.find(
    (item) => item.value === updatedSection.value
  );
  if (foundValueItem) {
    selectedText = foundValueItem.text;
  } else {
    updatedSection.value = 0;
  }

  setGroupMedicalSection(0, card, listItem, {
    ...updatedSection,
  });
  setGroupMedicalSection(1, card, listItem, {
    value: getMedicalInsuranceLabelPatternB(updatedSection.value, selectedText),
  });

  return calculateInsuranceFee(
    card,
    age,
    mappedSections[groupType],
    updatedSection.value,
    groupType
  );
};

// Check medical insurance for group N
const checkGroupMedicalInsuranceN = (card, age, mappedSections) => {
  const groupType = 'N型';
  let updatedSection = {
    disabled: false,
    value: mappedSections[groupType].sections[0].value,
  };

  // condition based on M型
  if (mappedSections['M型'].sections[0].value > 0) {
    updatedSection.disabled = true;
    updatedSection.value = 0;
  }

  const listItem = mappedSections[groupType];

  setGroupMedicalSection(0, card, listItem, {
    ...updatedSection,
  });
  return calculateInsuranceFee(
    card,
    age,
    mappedSections[groupType],
    updatedSection.value,
    groupType
  );
};

// Set group medical section
const setGroupMedicalSection = (
  sectionIndex,
  card,
  listItem,
  updatedSection
) => {
  const sectionValue =
    card.items[listItem.itemIndex].list[listItem.listItemIndex].sections[
      sectionIndex
    ];
  Vue.set(
    card.items[listItem.itemIndex].list[listItem.listItemIndex].sections,
    sectionIndex,
    { ...sectionValue, ...updatedSection }
  );

  return card.items[listItem.itemIndex].list[listItem.listItemIndex];
};

// Get group medical insurance label using pattern A
const getMedicalInsuranceLabelPatternA = (value, text) => {
  const labelNum = parseInt(text.replaceAll(',', ''));
  return value === 0
    ? '-'
    : '手術の種類に応じて\n' +
        (labelNum * 10) / 10000 +
        '~' +
        (labelNum * 40) / 10000 +
        '万円';
};

// Get group medical insurance label using pattern B
const getMedicalInsuranceLabelPatternB = (value, text) => {
  const labelNum = parseInt(text.replace('万円', '').replaceAll(',', ''));
  return value === 0
    ? '-'
    : '障害の程度に応じて\n' + labelNum * 0.04 + '~' + labelNum + '万円';
};

// Get group medical insurance label using pattern C
const getMedicalInsuranceLabelPatternC = (value) => {
  return value === 0 ? '-' : (value * 1000).toLocaleString() + '円';
};
